import type { IRowNode } from 'ag-grid-community';

type ComparisonResult = 0 | -1 | 1;
export type Comparator<T> = (
  valueA: T,
  valueB: T,
  recordA?: Record<string, unknown>,
  recordB?: Record<string, unknown>,
  isInverted?: boolean,
) => ComparisonResult;

export const toRowNodeComparator = <T,>(comparator?: Comparator<T>) =>
  comparator == null
    ? undefined
    : (
        valueA: T,
        valueB: T,
        nodeA: IRowNode,
        nodeB: IRowNode,
        isInverted: boolean,
      ) => comparator(valueA, valueB, nodeA.data, nodeB.data, isInverted);
